module.exports = __webpack_public_path__ + "static/media/ic-logout.73cee015.svg";